"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconWifiDisconnected = function SvgIconWifiDisconnected(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "wifi disconnected icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Wifi Disconnected Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.932 4.004l2.649 2.176L9.522 44l-2.654-2.18L37.928 4zM24.001 33.607a2.643 2.643 0 110 5.283 2.643 2.643 0 010-5.283zm3.943-6.634a9.99 9.99 0 013.188 2.16 1.98 1.98 0 01-2.8 2.797 6.074 6.074 0 00-3.089-1.669zm4.924-5.998a17.612 17.612 0 013.625 2.793 1.99 1.99 0 01-1.397 3.388 1.977 1.977 0 01-1.4-.583 13.65 13.65 0 00-3.388-2.478zm-11.536-2.173l-5.048 6.143a13.718 13.718 0 00-1.957 1.63 1.99 1.99 0 01-2.81 0 1.99 1.99 0 010-2.807 17.558 17.558 0 019.815-4.967zM37.8 14.975a25.164 25.164 0 014.135 3.346 1.99 1.99 0 01-1.4 3.388 1.977 1.977 0 01-1.397-.584 21.392 21.392 0 00-3.868-3.062zm-10.194-3.81l-3.043 3.711a21.32 21.32 0 00-15.68 6.252 1.99 1.99 0 01-2.803 0 1.99 1.99 0 010-2.807 25.342 25.342 0 0121.52-7.155z"
  }));
};

var _default = SvgIconWifiDisconnected;
exports.default = _default;